/*
NOTE: 
1. Use effect for search customer
https://www.udemy.com/course/react-the-complete-guide-incl-redux/learn/lecture/25599220#overview

2. async/await => Promise
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function


*/

import {
  Fragment,
  useState,
  useEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import customerServices from "../../services/customerServices";
import orderServices from "../../services/orderServices";
import ModalForForms from "../Modals/ModalForForms";
import customer from "./../../Models/customer";
import OrderRow from "./../../Components/Home/OrderRow";
// import { Redirect , history} from 'react-router';
import { Routes, Route, useNavigate } from "react-router-dom";
// React Notification
import { NotificationManager } from "react-notifications";

const CustomerOrderList = (props) => {
  const navigate = useNavigate();
  // (2) Load customer list
  //Customer
  const [enteredCustomerSearchField, setEnteredCustomerSearchField] =
    useState("");
  const [customerList, setCustomerList] = useState([]);
  const [rowNumber, setRowNumber] = useState(0);
  const customerListHtml = [];
  //Order
  const [customerOrderList, setCustomerOrderList] = useState([]);
  const [customerNameToOrder, setCustomerNameToOrder] = useState("");
  const [lstOrderShowed, setLstOrderShowed] = useState([]);

  // (**) Show Order detail by CustomerID
  const LoadOrderByCustomerID = async (customerID, customerName) => {
    // alert("Load Order by customer ID: " + customerID);
    console.log("Load Customer Orders-------");
    let customerOrderSearched = await orderServices.getOrderVMByCustomerID(
      customerID
    );
    // debugger;
    console.log("searched Order ----------> " + customerOrderSearched);
    setRowNumber(0);
    if (customerOrderSearched == null) {
      setCustomerOrderList([]);
    } else {
      setCustomerOrderList(customerOrderSearched);
    }
  };

  // function resolveAfter2Seconds() {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve("resolved");
  //     }, 2000);
  //   });
  // }

  useEffect(() => {
    LoadOrderByCustomerID(props.customerGUID, "test customer");

    // //(1) search
    // const identifier = setTimeout(async () => {
    //   debugger;
    //   console.log("Load Customer search-------");
    //   let customerSearched = await customerServices.searchNameOrPhone(
    //     enteredCustomerSearchField
    //   );
    //   debugger;
    //   console.log("searched customer ----------> " + customerSearched);
    //   setRowNumber(0);
    //   if (customerSearched == null) {
    //     setCustomerList([]);
    //   } else {
    //     setCustomerList(customerSearched);
    //   }
    //   console.log("customer list ----------> " + customerList.length);
    //   console.log("customerListHtml" + customerListHtml);
    // }, 500);

    // // (2) clear setTime out
    // return () => {
    //   console.log("clear timeout");
    //   clearTimeout(identifier);
    // };
  }, [props.customerGUID]);

  // if (loading) return <h1> LOADING...</h1>;
  // if (error) console.log(error);

  //*************** Check Box */
  const [checkedCustomerGUID, setCheckedCustomerGUID] = useState(0);
  const handleOnCheckBoxChange = (cusGuid) => {
    // alert(cusGuid);
    setCheckedCustomerGUID(cusGuid);
  };

  //********************************** Add Customer */
  const [showAddCustomerPopup, setShowAddCustomerPopup] = useState(false);
  const childSubmitButton = useRef(); // forwardRef(); // useRef(null);

  const AddCustomerPopup = () => {
    setShowAddCustomerPopup(true);
  };
  const AddCustomerToDB = (values) => {
    // alert("save it to DB from parent");
    console.log("values : " + values.Name);
    customerServices.save(values);
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="card-title">
                <h4>
                  Orders (
                  {
                    customerOrderList
                      .map((item) => item.orderID_GUID)
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      ).length
                  }
                  )
                  {/* {customerNameToOrder ? Customer - customerNameToOrder : ""} */}
                </h4>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>SI</th>
                      <th>Order Date</th>
                      <th>Order Number</th>
                      <th>Delivery Date</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerOrderList
                      .map((item) => item.orderID_GUID)
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      )
                      .map((orderGUID, i) => (
                        <>
                          <OrderRow
                            indexno={i + 1}
                            orderGUID={orderGUID}
                            customerOrderList={customerOrderList}
                            LoadOrderByCustomerID={LoadOrderByCustomerID}
                            customerGUID={props.customerGUID}
                          />

                          <tr>
                            <td colSpan="5">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>SI</th>
                                    <th>Name</th>
                                    <th>Qty</th>
                                    <th>Delivery Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {customerOrderList
                                    .filter((o) => o.orderID_GUID === orderGUID)
                                    .map((orderDetail, i) => {
                                      return (
                                        <tr>
                                          <th>{i + 1}</th>
                                          <td>
                                            {orderDetail.name}
                                            {/* {orderDetail.orderDetailID_GUID} */}
                                          </td>
                                          <td>{orderDetail.qty}</td>
                                          <td>
                                            {orderDetail.itemDeliveryDate}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CustomerOrderList;
